export default "__VITE_ASSET__BR4zPNm6__"